const DOCUMENT_STATUS = {
    PENDING: {
        key:"PENDING",
        textValue:"În așteptare"
    },
    APPROVED: {
        key:"APPROVED",
        textValue:"Aprobat"
    },
    PROCESSED: {
        key:"PROCESSED",
        textValue:"Procesat"
    },
    PROCESSED_UPDATED: {
        key:"PROCESSED_UPDATED",
        textValue:"Editat"
    },
    SENT_TO_OMC: {
        key:"SENT_TO_OMC",
        textValue:"Trimis la OMC"
    },
    SUPPORTING_DOCUMENT_UPLOAD: {
        key:"SUPPORTING_DOCUMENT_UPLOAD",
        textValue:"Document justificativ încărcat"
    },
    SUPPORTING_DOCUMENT_DELETE: {
        key:"SUPPORTING_DOCUMENT_DELETE",
        textValue:"Document justificativ șters"
    }
}

export default DOCUMENT_STATUS;
